import gql from 'graphql-tag';
import Interface from '../Interface';
import { FolderSchema } from '../../types/Folder';
import { contentViewFields } from '../Content/ContentFields';

interface GetFolderData {
  getFolder: FolderSchema;
}

export default class FolderInterface extends Interface {
  public async getFolder(id: string) {
    const data = await this.query<GetFolderData>(
      () =>
        this.apolloService.executeQuery<GetFolderData>({
          query: gql`
            query getFolder($id: ID!) {
              getFolder(id: $id) {
                id
                name
                structure
                itemCount
                depth
                parentFolder {
                  name
                }
                childFolders {
                  id
                  name
                }
                parentFolderId
                breadcrumbs {
                  id
                  name
                }
                roomObjectAclsContents
                contents {
                  ${contentViewFields}
                }
              }
            }
          `,
          variables: { id },
        }),
      'Error loading folder'
    );

    return data.getFolder;
  }
}
